import RelatedAdsLogo from '@/icons/RelatedAdsLogo';
import useMediaRules from '@/hooks/useMediaRules';

const RelatedAdsLogoMedia = () => {
    const {isBelowLaptopLg} = useMediaRules();
    return <RelatedAdsLogo {...(isBelowLaptopLg ? {width: 248, height: 50} : {width: 330, height: 66})} />;
};

export default RelatedAdsLogoMedia;
